// @flow
import {
  DOCUMENTS_CERTIFICATES_REQUEST,
  DOCUMENTS_CERTIFICATES_UPDATE,
  DOCUMENTS_CERTIFICATES_ERROR
} from './constants';

import type {
  Action, State, Documents, Document
} from '../types';

// eslint-disable-next-line max-len
const dataWithoutFileExtensions = (data: Documents): Documents => data.map((document: Document): Document => ({
  ...document,
  attributes: {
    ...document.attributes,
    name: document.attributes.name.replace(/\.[^/.]+$/, '')
  }
}));

const initialState: State = { requesting: false, data: [] };

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case DOCUMENTS_CERTIFICATES_REQUEST:
      return { ...state, requesting: true };
    case DOCUMENTS_CERTIFICATES_UPDATE: {
      return {
        ...state,
        requesting: false,
        data: dataWithoutFileExtensions(action.data || [])
      };
    }
    case DOCUMENTS_CERTIFICATES_ERROR:
      return { ...state, requesting: false };
    default:
      return state;
  }
};

export default reducer;
